import React, { useEffect } from 'react';
import { AlertBlock } from '../../components/AlertBlock';
import { getMaintenanceMessage } from '../../services/systemMessages';

const DEFAULT_TITLE = "We're down for maintenance";
const DEFAULT_CONTENT = "We're performing scheduled maintenance and will be back shortly.";
// index.html ships an empty <title>; ThemeService normally fills it, but Angular never boots here.
const DOCUMENT_TITLE = 'Maintenance - Folio';

function formatEnd(end: string | undefined): string | null {
  if (!end) return null;
  const date = new Date(end);
  if (isNaN(date.getTime())) return null;
  // Explicit fields, not dateStyle/timeStyle — Intl forbids combining those with timeZoneName.
  return date.toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short',
  });
}

export function MaintenancePage() {
  const config = getMaintenanceMessage();
  const title = config?.title || DEFAULT_TITLE;
  const content = config?.content || DEFAULT_CONTENT;
  const expectedBack = formatEnd(config?.expectedEnd);

  useEffect(() => {
    document.title = DOCUMENT_TITLE;
  }, []);

  return (
    <div className="container text-center" style={{ maxWidth: 600 }}>
      {/* Default theme's largeLogo, same as the login page. Hardcoded because ThemeService
          needs Angular and the API, neither of which is available here. */}
      <img
        className="img-responsive center-block"
        src="/images/FolioLogoColor.svg"
        alt="Folio"
        style={{ marginBottom: 30, marginTop: 60 }}
      />
      <AlertBlock type="warning" heading={title}>
        <p>{content}</p>
        {expectedBack && <p>Expected back by {expectedBack}</p>}
      </AlertBlock>
      <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>
        Try again
      </button>
    </div>
  );
}
